import {
  // UserSelections, this type seriously is the worst
  ExistingPreference,
} from '@aaa-ncnu-ie/digital-api-customer-prefs';
import { useQuery } from '@tanstack/react-query';
import axios, { AxiosError } from 'axios';

export interface PreferencePolicy {
  policyNumber: string;
  policySourceSystem: string;
}

export interface GetPreferencesResponse {
  existingPreferences: ExistingPreference[];
  selections: UserSelection[];
}

export const getPreferences = async (
  policiesArray?: PreferencePolicy[],
  authToken?: string
) => {
  if (!authToken) {
    return Promise.reject(new Error('Missing authToken'));
  }

  if (!policiesArray || policiesArray.length === 0) {
    return Promise.reject(new Error('Missing policiesArray'));
  }

  const policies = JSON.stringify(
    policiesArray.reduce(
      (acc, curr) => ({ ...acc, [curr.policyNumber]: curr.policySourceSystem }),
      {}
    )
  );

  const { data } = await axios.get<GetPreferencesResponse>(
    import.meta.env.VITE_PREFERENCES_URL,
    {
      headers: {
        policies,
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`,
        accept: 'application/json',
        clientid: 'cc_cccm', // need to get this
        'x-api-key': import.meta.env.VITE_PREFERENCES_X_API_KEY ?? '',
        system: 'custprl', // need to get this
        application: 'MYPOLICY_2',
        tokentype: 'b2c',
      },
    }
  );

  return data;
};

export const usePreferencesQuery = (
  authToken?: string,
  policiesArray?: PreferencePolicy[]
) =>
  useQuery({
    queryKey: ['preferences', ...(policiesArray ?? [])],
    queryFn: () => getPreferences(policiesArray, authToken),
    enabled: !!(authToken && policiesArray && policiesArray.length > 0),
  });
